import { lazy, Suspense, useEffect, useMemo, useState } from "react";
import { AppHeader, ToolErrorBoundary } from "@local-tools/ui-kit";
import { toolRegistry } from "./registry.generated";

function ToolLoading() {
  return (
    <section aria-live="polite" className="tool-loading" role="status">
      <div aria-hidden="true" className="tool-loading__rail">
        <span />
        <span />
        <span />
      </div>
      <p>Loading this local tool…</p>
    </section>
  );
}

export function App() {
  const [theme, setTheme] = useState<"light" | "dark">(() =>
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  );

  const activeEntry =
    toolRegistry.find((entry) => entry.manifest.route === window.location.pathname) ??
    toolRegistry[0];
  const ActiveTool = useMemo(
    () => lazy(activeEntry.load),
    [activeEntry]
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    const themeColor = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]'
    );
    themeColor?.setAttribute(
      "content",
      theme === "dark" ? "#151714" : "#f4f5f2"
    );
  }, [theme]);

  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to JWT Decoder
      </a>
      <AppHeader
        brand="devlocal.tools"
        currentToolId={activeEntry.manifest.id}
        onThemeToggle={() =>
          setTheme((value) => (value === "light" ? "dark" : "light"))
        }
        theme={theme}
        tools={toolRegistry.map((entry) => entry.manifest)}
      />
      <main className="app-main" id="main-content">
        <ToolErrorBoundary>
          <Suspense fallback={<ToolLoading />}>
            <ActiveTool />
          </Suspense>
        </ToolErrorBoundary>
      </main>
    </>
  );
}
